module.exports = {"TXTCLI_Please_enter_a_valid_SSN":{"id":"TXTCLI_Please_enter_a_valid_SSN","defaultMessage":"Ange ett giltigt SSN"}}